import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Hizmetlerimiz', path: '/hizmetler' },
    { name: 'Hakkımızda', path: '/hakkimizda' },
    { name: 'Çalışmalarımız', path: '/calismaalarimiz' },
    { name: 'Referanslar', path: '/referanslar' },
    { name: 'Blog', path: '/blog' },
    { name: 'Kariyer', path: '/kariyer' },
    { name: 'SSS', path: '/sss' },
    { name: 'İletişim', path: '/iletisim' }
  ];

  const services = [
    { name: 'Mobil Uygulama', path: '/services/mobile-app-development' },
    { name: 'Yapay Zeka', path: '/services/ai-integration' },
    { name: 'Web Tasarım', path: '/services/web-design' },
    { name: 'Dijital Büyüme', path: '/services/digital-growth' },
    { name: 'Sosyal Medya', path: '/services/social-media' },
    { name: 'E-Ticaret', path: '/services/ecommerce' }
  ];

  return (
    <footer className="bg-slate-950 border-t border-slate-800 relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl bottom-0 left-0"></div>
        <div className="absolute w-96 h-96 bg-teal-500/5 rounded-full blur-3xl bottom-0 right-0"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-8 py-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent mb-4 inline-block">
              RUYAN
            </Link>
            <p className="text-gray-400 text-sm mb-6">
              Veri odaklı dijital büyüme sistemleri kuran teknoloji şirketi.
              AI, kullanıcı davranışı ve analytics'i birleştirerek ölçülebilir sonuçlar üretiyoruz.
            </p>

            <p className="text-gray-500 text-xs">
              Sınırlı sayıda projeyle çalışıyor, her birine odaklanıyoruz.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hızlı Bağlantılar</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-cyan-400 transition-colors text-sm flex items-center group"
                  >
                    <span className="w-0 h-0.5 bg-cyan-400 group-hover:w-2 transition-all duration-300 mr-0 group-hover:mr-2"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hizmetler</h3>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.path}
                    className="text-gray-400 hover:text-cyan-400 transition-colors text-sm flex items-center group"
                  >
                    <span className="w-0 h-0.5 bg-cyan-400 group-hover:w-2 transition-all duration-300 mr-0 group-hover:mr-2"></span>
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">İletişim</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3 text-gray-400 text-sm hover:text-cyan-400 transition-colors">
                <div className="w-8 h-8 rounded-lg bg-slate-800/50 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Mail className="w-4 h-4 text-cyan-400" />
                </div>
                <a href="mailto:info@ruyan.com.tr">info@ruyan.com.tr</a>
              </div>
              <div className="flex items-start space-x-3 text-gray-400 text-sm hover:text-cyan-400 transition-colors">
                <div className="w-8 h-8 rounded-lg bg-slate-800/50 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Phone className="w-4 h-4 text-cyan-400" />
                </div>
                <a href="tel:+905542831771">0554 283 1771</a>
              </div>
              <div className="flex items-start space-x-3 text-gray-400 text-sm">
                <div className="w-8 h-8 rounded-lg bg-slate-800/50 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-cyan-400">📍</span>
                </div>
                <span>Withco Çınarlı, 1572/1. Sk. No:33, 35170 Konak/İzmir</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 pb-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} RUYAN Teknoloji ve Bilişim Hizmetleri Ltd. Şti. Tüm hakları saklıdır.
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              <Link to="/sozlesmeler" className="text-gray-500 hover:text-cyan-400 transition-colors text-sm">
                Gizlilik Politikası
              </Link>
              <Link to="/sozlesmeler" className="text-gray-500 hover:text-cyan-400 transition-colors text-sm">
                Kullanım Koşulları
              </Link>
              <Link to="/sozlesmeler" className="text-gray-500 hover:text-cyan-400 transition-colors text-sm">
                Çerez Politikası
              </Link>
              <Link to="/sozlesmeler" className="text-gray-500 hover:text-cyan-400 transition-colors text-sm">
                KVKK
              </Link>
              <Link to="/sitemap" className="text-gray-500 hover:text-cyan-400 transition-colors text-sm">
                Site Haritası
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
